import { roleDefinitions, type RoleId } from '../../config/access';
import { useAuth } from '../auth/auth-store';

export const useWorkspace = () => {
  const auth = useAuth();
  const context = auth.workspace?.activeContext;
  const organization = auth.workspace?.organizations.find((item) => item.id === context?.organizationId);
  const business = auth.workspace?.businesses.find((item) => item.id === context?.businessId);
  const branch = auth.workspace?.branches.find((item) => item.id === context?.branchId);
  const membership = auth.workspace?.memberships.find((item) => item.userId === auth.session?.user.id && item.businessId === context?.businessId);
  const role = (membership?.role ?? 'viewer') as RoleId;
  return {
    ...auth,
    organization,
    business,
    branch,
    membership,
    role,
    roleLabel: roleDefinitions[role].label,
  };
};
